import { atom } from "jotai";

export interface HamburgerMenu {
  isOpen: boolean;
}

export const hamburgerMenuAtom = atom<HamburgerMenu>({
  isOpen: false,
});
